// @flow

import axios from 'axios';
import { getBaseUrl } from '../../config/config';

export default function getProjectProjection(projectId: string): Promise<Object> {
  return axios.get(`${getBaseUrl()}projects/${projectId}/insights/projected_end_date`);
}
